import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MenuSide } from "../../components/MenuSide";
import { Button, TextField, FormControl } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import {
  tokenUsuario,
  urlAlterarContatos,
  urlInformacoesContatos,
  urlApagarContatos,
} from "../../utils/constants";
import ButtonCustom from "../../components/ButtonCustom";

export default function AlterarContatos() {
  const navigate = useNavigate();
  const [nome, setNome] = useState("");
  const [numero, setNumero] = useState("");

  const url = window.location.href;
  const urlBase = new URL(url);

  const informacoesContato = async () => {
    try {
      const response = await axios.post(urlInformacoesContatos, {
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const alterarInformacoes = async () => {
    try {
      const response = await axios.post(urlAlterarContatos, {
        nome: nome,
        numero: numero,
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      if (response.data == 1) {
        navigate({
          pathname: "/contatos",
        });
      }
    } catch (error) {
      return null;
    }
  };

  const excluirInformacoes = async () => {
    try {
      const response = await axios.post(urlApagarContatos, {
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      if (response.data == 1) {
        navigate({
          pathname: "/contatos",
        });
      }
    } catch (error) {
      return null;
    }
  };

  useEffect(() => {
    const run = async () => {
      const info = await informacoesContato();
      setNome(info.nome);
      setNumero(info.numero);
    };
    run();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-sm-2">
          <MenuSide />
        </div>
        <div className="col-sm-10">
          <br />
          <div className="card" style={{ marginRight: "1%" }}>
            <div className="card-header">
              <div className="row">
                <div
                  className="col-sm-3"
                  style={{ fontWeight: 700, fontSize: "25px" }}
                >
                  Alterar contato
                </div>
                <div className="col-sm-9 text-end">
                  <Button
                    color={"error"}
                    variant={"contained"}
                    onClick={() => {
                      excluirInformacoes();
                    }}
                    style={{
                      color: "#111B21",
                      width: 50,
                      height: 39,
                      borderRadius: "0.5rem",
                      marginTop: "4px",
                    }}
                  >
                    <DeleteForeverOutlinedIcon style={{ color: "#ffffff" }} />
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <h6>Nome do contato</h6>
                  <FormControl fullWidth>
                    <TextField
                      placeholder="Nome do contato"
                      onChange={(event) => {
                        event.preventDefault();
                        setNome(event.target.value);
                      }}
                      value={nome}
                      type="text"
                      InputProps={{
                        sx: {
                          height: "39px",
                          borderRadius: "0.5rem",
                          width: "100%",
                          padding: "10px",
                        },
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </div>
                <div className="col-sm-3">
                  <h6>Número</h6>
                  <FormControl fullWidth>
                    <TextField
                      placeholder="Número"
                      onChange={(event) => {
                        event.preventDefault();
                        setNumero(event.target.value);
                      }}
                      value={numero}
                      type="text"
                      InputProps={{
                        sx: {
                          height: "39px",
                          borderRadius: "0.5rem",
                          width: "100%",
                          padding: "10px",
                        },
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-7"></div>
                <div className="col-sm-2 text-end">
                  <ButtonCustom
                    onClick={() => {
                      alterarInformacoes();
                    }}
                    color={"error"}
                    texto={"Confirmar"}
                    icon={null}
                  />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
